<svg
  width="24"
  height="25"
  viewBox="0 0 24 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M11.9995 8.96902C11.9996 8.10742 12.2963 7.27212 12.8398 6.60355C13.3833 5.93499 14.1404 5.47392 14.9838 5.29788C15.8272 5.12184 16.7056 5.24155 17.4711 5.63689C18.2367 6.03223 18.8427 6.67909 19.1875 7.46872L22.4995 7.46875L19.4749 10.4934C19.278 13.5355 17.9306 16.3887 15.7065 18.4736C13.4823 20.5584 10.5481 21.7187 7.49953 21.7188C4.49953 21.7188 3.74953 20.5938 3.74953 20.5938C3.74953 20.5938 6.74953 19.4688 8.24953 17.2188C8.24953 17.2188 2.24953 14.2188 3.74953 5.96875C3.74953 5.96875 7.49953 9.71875 11.9982 10.4688L11.9995 8.96902Z"
    stroke="currentColor"
    stroke-width="1.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
